import React from "react";
import OrdersView from "./OrdersView";

export function OrdersContainer() {
  return <OrdersView title="Orders" />;
}
